import React from "react";
import { Modal, TextInput } from "@mantine/core";
import { ButtonWithIcon } from "../ButtonWithIcon";
import { LexWorkplaceCheckIcon, LexWorkplaceXIcon } from "../LexWorkplaceIcons";

export default function EditItemDialog({
	editItemDialogOpen,
	closeEditItemDialog,
	title,
	editItemText,
	editItemUrl,
	handleEditItemChange,
	submitEditItemDialog,
}) {
	return (
		<Modal
			opened={editItemDialogOpen}
			onClose={closeEditItemDialog}
			size="sm"
			title={title}
		>
			<div style={{ marginBottom: 10 }}>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: 20,
						marginBottom: 20,
					}}
				>
					<TextInput
						label="Item Text"
						placeholder="Enter Item Text"
						name="editItemText"
						value={editItemText}
						onChange={(e) =>
							handleEditItemChange(e, "editItemText")
						}
					/>
					<TextInput
						label="Item URL"
						placeholder="Enter Item URL"
						name="editItemUrl"
						value={editItemUrl}
						onChange={(e) => handleEditItemChange(e, "editItemUrl")}
					/>
				</div>
				<div style={{ display: "flex", gap: 10 }}>
					<ButtonWithIcon
						handler={closeEditItemDialog}
						buttonText="Cancel"
						iconComponent={<LexWorkplaceXIcon />}
					/>

					<ButtonWithIcon
						className="blue"
						handler={submitEditItemDialog}
						buttonText="Save"
						iconComponent={<LexWorkplaceCheckIcon />}
					/>
				</div>
			</div>
		</Modal>
	);
}
